import InlineAlert from 'src/components/primitives/InlineAlert/InlineAlert';

export const MaxSubaccountsWarning = () => {
	return (
		<InlineAlert variant="error" title="Max number of subaccounts reached">
			Due to a huge influx of new user account creations, we&apos;ve hit maximum
			capacity of users on the Drift smart contract. The capacity will be
			upgraded soon. Please try again later.
		</InlineAlert>
	);
};
